/**
 * Created by Jamsheed on 14/07/16.
 */
class ConvexHullMaker {
    static cross(o, a, b) {
        return (a[0] - o[0]) * (b[1] - o[1]) - (a[1] - o[1]) * (b[0] - o[0]);
    }

    /**
     * @param points An array of [X, Y] coordinates
     */
    static monotoneConvexHull(points) {
        points.sort(function (a, b) {
            return a[0] == b[0] ? a[1] - b[1] : a[0] - b[0];
        });

        var lower = [];
        for (var i = 0; i < points.length; i++) {
            while (
                lower.length >= 2 &&
                ConvexHullMaker.cross(
                    lower[lower.length - 2],
                    lower[lower.length - 1],
                    points[i]
                ) <= 0
            ) {
                lower.pop();
            }
            lower.push(points[i]);
        }

        var upper = [];
        for (var i = points.length - 1; i >= 0; i--) {
            while (
                upper.length >= 2 &&
                ConvexHullMaker.cross(
                    upper[upper.length - 2],
                    upper[upper.length - 1],
                    points[i]
                ) <= 0
            ) {
                upper.pop();
            }
            upper.push(points[i]);
        }

        upper.pop();
        lower.pop();
        return lower.concat(upper);
    }

    static monotoneConvexHullFromLatLngs(latLngs) {
        var points = latLngs
            .filter(function (latLng) {
                return latLng.lat != null && latLng.lng != null;
            })
            .map(function (latLng) {
                return [latLng.lat, latLng.lng];
            });
        var hullpoints = ConvexHullMaker.monotoneConvexHull(points);
        var hullLatLngs = hullpoints.map(function (hullpoint) {
            return { lat: hullpoint[0], lng: hullpoint[1] };
        });
        return hullLatLngs;
    }
}

export default ConvexHullMaker;
